export default __webpack_public_path__ + "static/media/cold-macchiato.fa6ad0f2.png";